/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackupCode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15 7H3v10h9.083c.12-.718.368-1.393.72-2H5V9h10zm2 0v7.126A4.002 4.002 0 0 0 18 22a4 4 0 0 0 1-7.874V13h2v-2h-2V9h2V7zm3 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
        <path d="M7 11h2v2H7zm4 0h2v2h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgBackupCode as BackupCode };
